import type { CanvasserStatsItem } from '@signalvote/shared';
import { CanvasserType } from '@signalvote/shared';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '../ui/table';

interface VolunteerLeaderboardProps {
  canvasserStats: CanvasserStatsItem[];
}

export function VolunteerLeaderboard({ canvasserStats }: VolunteerLeaderboardProps) {
  const volunteers = canvasserStats
    .filter((c) => c.canvasserType === CanvasserType.Volunteer)
    .sort((a, b) => b.doorsKnocked - a.doorsKnocked);

  return (
    <Card>
      <CardHeader>
        <CardTitle>Volunteer Leaderboard</CardTitle>
      </CardHeader>
      <CardContent>
        {volunteers.length === 0 ? (
          <p className="text-sm text-muted-foreground">No volunteer data yet</p>
        ) : (
          <div className="rounded-md border">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead className="w-[60px] text-xs font-semibold uppercase tracking-wider">Rank</TableHead>
                  <TableHead className="text-xs font-semibold uppercase tracking-wider">Name</TableHead>
                  <TableHead className="text-right text-xs font-semibold uppercase tracking-wider">Doors</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {volunteers.map((v, i) => (
                  <TableRow key={v.userId} className="even:bg-muted/30 transition-colors duration-150">
                    <TableCell className="tabular-nums">{i + 1}</TableCell>
                    <TableCell>
                      {v.firstName} {v.lastName}
                    </TableCell>
                    <TableCell className="text-right tabular-nums">{v.doorsKnocked}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
